import { useState } from "react";
import Eyebrow from "./Eyebrow.jsx";

const faqs = [
  {
    question: "What does Version3 do?",
    answer:
      "Version3 is a software company that designs, builds, and scales products around how your business actually runs. We work across custom software, SaaS products, web and mobile applications, AI solutions, workflow automation, CRM, e-commerce, integrations, and more.",
  },
  {
    question: "What types of software can Version3 build?",
    answer:
      "We build a wide range of digital products, including SaaS platforms, web applications, mobile apps, CRM and ERP systems, e-commerce platforms, marketplaces, internal business tools, dashboards, automation systems, customer-support platforms, and AI-powered applications.",
  },
  {
    question: "Can Version3 integrate AI into my product or business?",
    answer:
      "Yes. We can integrate AI into existing products and workflows, including AI assistants, conversational agents, document processing, intelligent search, recommendation systems, automated classification, content generation, and AI-powered workflow automation.",
  },
  {
    question: "Can Version3 build an MVP for my startup?",
    answer:
      "Yes. We can help turn an early-stage idea into a functional MVP, from product strategy and UI/UX design to development, integrations, deployment, and iteration.",
  },
  {
    question: "How does a project with Version3 usually start?",
    answer:
      "We start by understanding your business, users, requirements, existing systems, and desired outcomes. From there, we define the scope, recommend an appropriate technical approach, and create a development plan.",
  },
  {
    question: "Do you provide maintenance and ongoing support?",
    answer:
      "Yes. We can continue supporting products after launch through maintenance, monitoring, bug fixes, performance improvements, new features, integrations, and ongoing development.",
  },
];

export default function FAQ() {
  const [openItems, setOpenItems] = useState(() => new Set([0]));

  function toggleFaq(index) {
    setOpenItems((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  }

  return (
        <section className="section faq" id="faq">
         <div className="padding-global">
          <div className="container-medium">
           <div className="faqs-layout">
            <div className="heading-layout">
             <Eyebrow section="faq" />
             <div className="heading-wrap">
              <h2 className="heading-style-h2">
               Common Questions
              </h2>
             </div>
            </div>
            <div className="faqs-main">
             <div className="faq-list">
              {faqs.map((faq, index) => (
              <div className="faq-item" key={faq.question}>
               <div className={`faq-item-inner${openItems.has(index) ? " is-open" : ""}`}>
                <button type="button" aria-controls={`faq-panel-${index}`} aria-expanded={openItems.has(index)} className="faq-item-top" id={`faq-question-${index}`} onClick={() => toggleFaq(index)}>
                 <span className="faq-item-question-wrap">
                  <span className="faq-item-number">
                   {index + 1}
                  </span>
                  <span className="faq-item-question">
                   {faq.question}
                  </span>
                 </span>
                 <span className="faq-item-icon" aria-hidden="true">
                  <span className="faq-item-icon-inner">
                   <svg className="faq-item-icon-icon" fill="none" viewBox="0 0 24 24">
                    <path d="M12 5V19" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                    <path d="M5 12H19" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                   </svg>
                  </span>
                  <span className="faq-icon-bg-gradient" />
                 </span>
                </button>
                {/* 0fr -> 1fr grid row: the browser animates the panel's real height, no per-frame JS */}
                <div className="faq-panel" id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-question-${index}`}>
                 <div className="faq-panel-clip">
                  <div className="faq-item-bottom">
                   <div className="faq-item-answer">
                    <p className="faq-item-answer-text">
                     {faq.answer}
                    </p>
                   </div>
                  </div>
                 </div>
                </div>
               </div>
               <div className="faq-item-bg-gradient">
               </div>
              </div>
              ))}
             </div>
             <div className="faqs-cta">
              <div className="faqs-cta-text">
               Have any other questions?
              </div>
              <a className="button button--primary u-inline-block" href="#CTA-Form">
               <div className="button-inner button--primary">
                <div className="button-text-wrap">
                 <div className="button-text button--primary">
                  Contact Us
                 </div>
                </div>
                <div className="button-icon button--primary">
                 <div className="icon-button u-embed">
                  <svg aria-hidden="true" fill="none" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16" width="100%" xmlns="http://www.w3.org/2000/svg">
                   <g clipPath="url(#clip0_6234_2207)">
                    <path d="M3.33301 8H12.6663" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                    </path>
                    <path d="M10 10.6667L12.6667 8" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                    </path>
                    <path d="M10 5.33333L12.6667 8" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                    </path>
                   </g>
                   <defs>
                    <clipPath id="clip0_6234_2207">
                     <rect fill="currentColor" height="16" width="16">
                     </rect>
                    </clipPath>
                   </defs>
                  </svg>
                 </div>
                </div>
               </div>
               <div className="button-innershadow button--primary">
               </div>
              </a>
             </div>
            </div>
           </div>
          </div>
         </div>
        </section>
  );
}
